import React from 'react';
import config from 'utils/config';

const PlayerSkillIcon = ({ skillType }) => {
  let skillIcon = config.skillObj.find((e) => e.id === skillType);
  return (
    <>
      <div className='si-playerSkillIcon'>
        <i className={skillIcon.skill_icon}></i>
      </div>
    </>
  );
};

export default PlayerSkillIcon;
